import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './components/Login/LoginPage.js';
import RegistrationPage from './components/SignUp/RegistrationPage.js';
import { useState, useMemo, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports';
import Intro from './components/Intro/index.js';
import FAQ from './components/Intro/Help/index.js';
import DisclaimerModal from './components/DisclaimerModal/index.js';
import Unauthorized from './components/Unauthorized.js';
import MaintenancePage from './components/Maintainance.js';
import { FooterContext } from './store/FooterContext.js';
import "./App.css";
import SalesContact from './components/Intro/SalesContact/index.js';



Amplify.configure(awsConfig);

function App() {
  const [footerData, setFooterData] = useState({});

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const res = await fetch("https://5549ucvkb3.execute-api.us-east-2.amazonaws.com");
        const data = await res.json();

        const body = typeof data.body === "string"
          ? JSON.parse(data.body)
          : data;

        if (body.footer) {
          setFooterData(body.footer);
        }

      } catch (err) {
        console.error("Footer Fetch Error:", err);
      }
    };

    fetchFooter();
  }, []);

  const contextValue = useMemo(() => ({
    footerData,
    setFooterData
  }), [footerData]);

  return (
    <Router>
      <FooterContext.Provider value={contextValue}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Intro />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<RegistrationPage />} />
          <Route path="/help" element={<FAQ />} />
          <Route path="/help/:username" element={<FAQ />} />
          <Route path="/sales" element={<SalesContact />} />
          <Route path="/privacy-policy" element={<DisclaimerModal />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/error" element={<MaintenancePage />} />
        </Routes>
      </FooterContext.Provider>
    </Router>

  );
}

export default App;
